var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _rect7, _rect8, _rect9, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomizableLearningPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.22,28.62V22.81H59.37A13.85,13.85,0,0,0,50,26.36a14.2,14.2,0,0,0-9.37-3.55H23.78v5.81H19.9V71.38H43.28a6.79,6.79,0,0,0,13.44,0H80.1V28.62ZM25.71,24.74H40.63A12,12,0,0,1,49,28.1v20H51v-20a12.22,12.22,0,0,1,8.4-3.36H74.29V65.57H51V50H49V65.57H25.71Zm52.45,44.7H54.84v1a4.84,4.84,0,1,1-9.68,0v-1H21.84V30.56h1.94V67.5H76.22V30.56h1.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.22,36.69A8.76,8.76,0,1,0,31.53,49.74V52a5.81,5.81,0,1,0,11.62,0V49.74a8.64,8.64,0,0,0,2.91-6.52A8.54,8.54,0,0,0,43.22,36.69ZM33.46,50h7.76v1.94H33.46Zm2.91-6.78a1,1,0,1,1,1,1A1,1,0,0,1,36.37,43.22Zm1,12.59A3.94,3.94,0,0,1,34,53.88H40.7A3.78,3.78,0,0,1,37.34,55.81Zm4.78-7.75H38.37V45.93a2.94,2.94,0,0,0,1.94-2.71,2.91,2.91,0,1,0-3.87,2.71v2.13H32.69a6.8,6.8,0,0,1,3.94-11.62c.26,0,.52-.07.77-.07a6.63,6.63,0,0,1,4.53,1.75,6.79,6.79,0,0,1,.19,9.94Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.65,
    y: 59.69,
    width: 1.94,
    height: 1.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.53,
    y: 59.69,
    width: 11.69,
    height: 1.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.16,
    y: 59.69,
    width: 1.94,
    height: 1.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.37,
    y: 27.65,
    width: 1.94,
    height: 3.88
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.58,
    y: 29.46,
    width: 1.94,
    height: 3.88,
    transform: "translate(-11.6 19.48) rotate(-30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.24,
    y: 30.4,
    width: 3.88,
    height: 1.94,
    transform: "translate(-5.08 53.95) rotate(-60.01)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.38 37.34 69.44 37.34 69.44 26.68 67.5 26.68 67.5 37.34 65.57 37.34 65.57 29.59 63.63 29.59 63.63 37.34 61.69 37.34 61.69 32.49 59.69 32.49 59.69 37.34 57.75 37.34 57.75 35.4 55.81 35.4 55.81 37.34 53.88 37.34 53.88 39.34 71.38 39.34 71.38 37.34"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.88,
    y: 42.25,
    width: 17.5,
    height: 1.94
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.88,
    y: 46.12,
    width: 7.75,
    height: 1.94
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 63.63,
    y: 46.12,
    width: 7.75,
    height: 1.94
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.81,63.63a2.89,2.89,0,0,0,2.91-2.91,2.67,2.67,0,0,0-.32-1.22l2.9-2.91a2.52,2.52,0,0,0,2.46,0l2.9,2.91a2.67,2.67,0,0,0-.32,1.22,2.91,2.91,0,1,0,2.91-2.9,2.62,2.62,0,0,0-1.23.32l-2.91-2.91A2.6,2.6,0,0,0,65.44,54a2.91,2.91,0,0,0-5.82,0A2.6,2.6,0,0,0,60,55.23l-2.84,2.84a2.74,2.74,0,0,0-1.23-.32A2.89,2.89,0,0,0,53,60.66,2.86,2.86,0,0,0,55.81,63.63Zm13.63-3.94a1,1,0,0,1,0,1.94,1,1,0,1,1,0-1.94Zm-6.78-6.78a1,1,0,1,1-1,1A1,1,0,0,1,62.66,52.91Zm-6.85,6.78a1,1,0,0,1,0,1.94,1,1,0,0,1-1-1A1,1,0,0,1,55.81,59.69Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableLearningPath);
export default __webpack_public_path__ + "static/media/CustomizableLearningPath.71d3f4f72c1d2bbcb242d12583cfcd5e.svg";
export { ForwardRef as ReactComponent };